const columns = [
  { name: "Objetivo", value: "learningObjectiveName", filter: true },
  { name: "Nota", value: "averagePercentage", filter: false },
  { name: "Tempo médio", value: "averageTimeSpent", filter: false },
  { name: "Tentativas", value: "userAttempts", filter: false },
  { name: "Aprov. na 1ª tentativa", value: "firstAttempt", filter: false },
  { name: "Aprov. na 2ª tentativa", value: "secondAttempt", filter: false },
  {
    name: "Aprov. na 3ª tent. ou +",
    value: "thirdOrMoreAttempt",
    filter: false,
  },
  { name: "Turma", value: "classroomName", filter: false },
];

export { columns };
